import { render, staticRenderFns } from "./safety-fence.vue?vue&type=template&id=273d3412&scoped=true&"
import script from "./safety-fence.vue?vue&type=script&lang=js&"
export * from "./safety-fence.vue?vue&type=script&lang=js&"
import style0 from "./safety-fence.vue?vue&type=style&index=0&id=273d3412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d3412",
  null
  
)

export default component.exports